module.exports = __webpack_public_path__ + "img/FalconEdgeFull-White.dc33bd4.png";